/**
 * TUVAL HESAPLAMA — FRONTEND v5 (Retry + Şase Uyarısı)
 * Backend API'ye istek atar, fiyat gösterir, dinamik görsel günceller
 */
(function () {
  'use strict';

  var API_URL = window.__TUVAL_API_URL || 'https://mtvs-tuval-api.vercel.app/api/hesapla';

  var configEl = document.getElementById('tuval-config-data');
  if (!configEl) return;

  var els = {
    sase: document.getElementById('tuval-sase'),
    bez: document.getElementById('tuval-bez'),
    en: document.getElementById('tuval-en'),
    boy: document.getElementById('tuval-boy'),
    priceCard: document.getElementById('tuval-price-card'),
    priceAmount: document.getElementById('tuval-price-amount'),
    priceDisplay: document.getElementById('tuval-price-display'),
    addToCart: document.getElementById('tuval-add-to-cart'),
    ebatError: document.getElementById('tuval-ebat-error'),
    saseWarning: document.getElementById('tuval-sase-warning'),
    specs: document.getElementById('tuval-specs'),
    placeholder: document.getElementById('tuval-placeholder'),
    canvasWrap: document.getElementById('tuval-canvas-wrap'),
    canvasFrame: document.getElementById('tuval-canvas-frame'),
    dimEn: document.getElementById('tuval-dim-en'),
    dimBoy: document.getElementById('tuval-dim-boy'),
    canvasLabel: document.getElementById('tuval-canvas-label'),
    qty: document.getElementById('tuval-qty'),
    qtyMinus: document.getElementById('tuval-qty-minus'),
    qtyPlus: document.getElementById('tuval-qty-plus'),
  };

  var lastResult = null;
  var fetchController = null;

  function formatTL(amount) {
    return new Intl.NumberFormat('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount);
  }

  // ─── DİNAMİK TUVAL ÖNİZLEME ───
  function updateMedia(en, boy) {
    if (!en || !boy || en < 10 || boy < 10) {
      els.placeholder.style.display = 'flex';
      els.canvasWrap.style.display = 'none';
      return;
    }

    els.placeholder.style.display = 'none';
    els.canvasWrap.style.display = 'flex';

    var containerW = els.canvasWrap.offsetWidth - 80;
    var containerH = els.canvasWrap.offsetHeight - 60;
    var maxSize = Math.min(containerW, containerH, 400);

    var ratio = en / boy;
    var frameW, frameH;

    if (ratio >= 1) {
      frameW = maxSize;
      frameH = Math.round(maxSize / ratio);
    } else {
      frameH = maxSize;
      frameW = Math.round(maxSize * ratio);
    }

    frameW = Math.max(frameW, 60);
    frameH = Math.max(frameH, 60);

    els.canvasFrame.style.width = frameW + 'px';
    els.canvasFrame.style.height = frameH + 'px';

    els.dimEn.textContent = '← ' + en + ' cm →';
    els.dimBoy.textContent = '← ' + boy + ' cm →';

    var sase = els.sase.value;
    var bez = els.bez.value;
    var lines = [en + ' × ' + boy + ' cm'];
    if (sase) lines.push('Şase: ' + sase);
    if (bez) lines.push('Bez: ' + bez);
    els.canvasLabel.textContent = lines.join('\n');
  }

  // ─── ŞASE UYARISI KONTROL ───
  function checkSaseWarning(en, boy, sase) {
    if (!els.saseWarning) return;

    if (en >= 180 && boy >= 180 && sase) {
      // Parantez içindeki ölçüyü çıkar
      var saseKey = sase;
      var p = sase.match(/\(([^)]+)\)/);
      if (p) saseKey = p[1];

      if (saseKey !== '4x6') {
        els.saseWarning.innerHTML = '⚠️ <strong>180 cm ve üzeri tuvallerde Master (4x6) şase kullanmanızı tavsiye ederiz.</strong> Düşük şase kalınlıklarında tuval yüzeyinde eğilme riski oluşabilir.';
        els.saseWarning.classList.add('visible');
        return;
      }
    }

    els.saseWarning.classList.remove('visible');
  }

  // ─── VALİDASYON ───
  function validate() {
    var saseCinsi = els.sase.value;
    var bezCinsi = els.bez.value;
    var en = parseInt(els.en.value, 10);
    var boy = parseInt(els.boy.value, 10);

    els.ebatError.classList.remove('visible');
    els.ebatError.textContent = '';

    if (!saseCinsi || !bezCinsi) return null;
    if (!en || !boy || isNaN(en) || isNaN(boy)) return null;

    if (en < 10 || boy < 10) {
      els.ebatError.textContent = 'Minimum ebat 10 cm olmalıdır.';
      els.ebatError.classList.add('visible');
      return null;
    }

    if (en > 200 || boy > 200) {
      els.ebatError.textContent = 'Maksimum ebat 200 cm olabilir.';
      els.ebatError.classList.add('visible');
      return null;
    }

    return { en: en, boy: boy, sase: saseCinsi, bez: bezCinsi };
  }

  // ─── BACKEND'E FİYAT SOR ───
  async function fetchPrice(input) {
    if (fetchController) fetchController.abort();
    fetchController = new AbortController();

    try {
      var res = await fetch(API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(input),
        signal: fetchController.signal,
      });

      if (!res.ok) {
        var err = await res.json().catch(function() { return {}; });
        throw new Error(err.error || 'API hatası');
      }

      return await res.json();
    } catch (e) {
      if (e.name === 'AbortError') return null;
      throw e;
    }
  }

  // ─── SEPETE EKLEME (RETRY MEKANİZMALI) ───
  async function addToCartWithRetry(variantId, qty, maxRetries) {
    for (var attempt = 0; attempt <= maxRetries; attempt++) {
      var cartRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: parseInt(variantId, 10),
            quantity: qty,
            properties: {
              'Ebat': lastResult.en + ' × ' + lastResult.boy + ' cm',
              'Şase': lastResult.sase,
              'Bez': lastResult.bez,
            },
          }],
        }),
      });

      if (cartRes.ok) return true;

      if (cartRes.status === 422 && attempt < maxRetries) {
        console.log('[Tuval] Sepet 422 hatası, ' + (attempt + 1) + '. deneme... 2sn bekleniyor');
        await new Promise(function(r) { setTimeout(r, 2000); });
        continue;
      }

      throw new Error('Sepete ekleme başarısız (HTTP ' + cartRes.status + ')');
    }
  }

  // ─── UI GÜNCELLE ───
  async function updateUI() {
    var input = validate();

    var en = parseInt(els.en.value, 10);
    var boy = parseInt(els.boy.value, 10);
    updateMedia(isNaN(en) ? 0 : en, isNaN(boy) ? 0 : boy);

    // Şase uyarısını her durumda kontrol et
    checkSaseWarning(isNaN(en) ? 0 : en, isNaN(boy) ? 0 : boy, els.sase.value);

    if (!input) {
      els.priceCard.classList.remove('visible');
      els.priceDisplay.innerHTML = '<span class="tuval-price-empty">Fiyat hesaplanacak</span>';
      els.addToCart.disabled = true;
      els.specs.style.display = 'none';
      lastResult = null;
      return;
    }

    els.priceDisplay.innerHTML = '<span style="color:#999;">Hesaplanıyor...</span>';
    els.addToCart.disabled = true;

    try {
      var result = await fetchPrice(input);
      if (!result) return;

      lastResult = { fiyat: result.fiyat, kayitAdet: result.kayitAdet, en: input.en, boy: input.boy, sase: input.sase, bez: input.bez };

      els.priceDisplay.innerHTML = '<span class="tuval-price-main">' + formatTL(result.fiyat) + '</span><span style="font-size:16px;color:#666;margin-left:4px;">TL</span>';
      els.priceAmount.textContent = formatTL(result.fiyat);
      els.priceCard.classList.add('visible');

      var specsHtml = '<span class="tuval-spec-tag">' + input.en + ' × ' + input.boy + ' cm</span>';
      specsHtml += '<span class="tuval-spec-tag">Şase: ' + input.sase + '</span>';
      specsHtml += '<span class="tuval-spec-tag">' + input.bez + '</span>';
      if (result.kayitAdet > 0) {
        specsHtml += '<span class="tuval-spec-tag">' + result.kayitAdet + ' Kayıt</span>';
      }
      els.specs.innerHTML = specsHtml;
      els.specs.style.display = 'flex';
      els.addToCart.disabled = false;

    } catch (err) {
      console.error('[Tuval] Fiyat hatası:', err.message);
      els.priceDisplay.innerHTML = '<span style="color:#e94560;">Hesaplama hatası</span>';
      els.addToCart.disabled = true;
    }
  }

  // ─── SEPETE EKLEME ───
  async function addToCart() {
    if (!lastResult || els.addToCart.disabled) return;

    els.addToCart.classList.add('loading');
    els.addToCart.disabled = true;

    try {
      var result = await fetchPrice({
        en: lastResult.en,
        boy: lastResult.boy,
        sase: lastResult.sase,
        bez: lastResult.bez,
        action: 'add_to_cart',
      });

      if (!result || !result.variantId) throw new Error('Variant oluşturulamadı');

      var qty = parseInt(els.qty.value, 10) || 1;

      await new Promise(function(r) { setTimeout(r, 2000); });
      await addToCartWithRetry(result.variantId, qty, 3);

      showNotification(qty);

    } catch (err) {
      console.error('[Tuval] Sepet hatası:', err);
      alert('Sepete eklenirken bir hata oluştu. Lütfen tekrar deneyin.');
    } finally {
      els.addToCart.classList.remove('loading');
      els.addToCart.disabled = false;
    }
  }

  function showNotification(qty) {
    var existing = document.querySelector('.tuval-cart-notif');
    if (existing) existing.remove();

    var div = document.createElement('div');
    div.className = 'tuval-cart-notif';
    div.innerHTML = '<div style="position:fixed;bottom:24px;right:24px;z-index:9999;background:#000;color:#fff;padding:16px 24px;border-radius:4px;box-shadow:0 8px 30px rgba(0,0,0,0.15);display:flex;align-items:center;gap:12px;animation:tuvalFadeIn .3s;font-size:14px;">' +
      '<span style="font-size:18px;">✓</span>' +
      '<div><div style="font-weight:600;">Sepete Eklendi</div>' +
      '<div style="opacity:0.7;font-size:12px;margin-top:2px;">' + qty + ' adet ' + lastResult.en + 'x' + lastResult.boy + 'cm</div></div>' +
      '<a href="/cart" style="margin-left:12px;padding:8px 16px;background:#fff;color:#000;text-decoration:none;font-weight:600;font-size:13px;">Sepete Git</a>' +
      '</div>';

    if (!document.getElementById('tuval-notif-css')) {
      var style = document.createElement('style');
      style.id = 'tuval-notif-css';
      style.textContent = '@keyframes tuvalFadeIn{from{transform:translateY(10px);opacity:0}to{transform:translateY(0);opacity:1}}';
      document.head.appendChild(style);
    }

    document.body.appendChild(div);
    setTimeout(function() { div.remove(); }, 5000);
  }

  // ─── ADET KONTROL ───
  els.qtyMinus.addEventListener('click', function() {
    var v = parseInt(els.qty.value, 10) || 1;
    if (v > 1) els.qty.value = v - 1;
  });

  els.qtyPlus.addEventListener('click', function() {
    var v = parseInt(els.qty.value, 10) || 1;
    if (v < 99) els.qty.value = v + 1;
  });

  // ─── EVENT LISTENERS ───
  var debounceTimer;
  function debouncedUpdate() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(updateUI, 400);
  }

  els.sase.addEventListener('change', updateUI);
  els.bez.addEventListener('change', updateUI);
  els.en.addEventListener('input', debouncedUpdate);
  els.boy.addEventListener('input', debouncedUpdate);
  els.addToCart.addEventListener('click', addToCart);

  [els.en, els.boy].forEach(function(input) {
    input.addEventListener('keypress', function(e) {
      if (!/[0-9]/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Tab') {
        e.preventDefault();
      }
    });
  });

})();
